export const sessionCard = (theme) => {
  return {
    padding: "50px 100px",
    backgroundColor: "white",
    [theme.breakpoints.down("sm")]: {
      padding: "0px",
    },
  };
};
